const scope = {
    name_exists: 'Der Scope-Name {{name}} ist bereits in Verwendung',
    name_with_space: 'Der Name des Scopes darf keine Leerzeichen enthalten.',
};
export default scope;
